import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/performance";
import json from './firebaseConfig'
firebase.initializeApp(json);
export default firebase;
export const firestore = firebase.firestore();

